export default function DeleteIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none" >
      <path
        d="M3.93447 19.2032C3.30481 19.2032 2.76822 18.9815 2.32472 18.538C1.88122 18.0945 1.65947 17.5579 1.65947 16.9282V4.06574H0.521973V1.79074H5.86272V0.653244H12.1257V1.79074H17.4785V4.06574H16.341V16.9282C16.341 17.5579 16.1192 18.0945 15.6757 18.538C15.2322 18.9815 14.6956 19.2032 14.066 19.2032H3.93447ZM5.89272 14.994H8.03022V5.99399H5.89272V14.994ZM9.97022 14.994H12.1077V5.99399H9.97022V14.994Z"
        fill="#B53129"
      />
    </svg>
  );
}
